import { ApiWithToken } from "../axios-instance";

export const aulaService = {
  uri: "/api/aula/student/",
  getActiveCourses: async () =>
    ApiWithToken.get(`${aulaService.uri}active_courses/`),
  getAvailableCourses: async () =>
    ApiWithToken.get(`${aulaService.uri}available_courses/`),
  getActiveAndAvailableCourses: async () =>
    ApiWithToken.get(`${aulaService.uri}active_and_available_courses/`),
  getActiveCourseById: async (id: number) =>
    ApiWithToken.get(`${aulaService.uri}progress/?course=${id}`),
  getStudentExcelByCourseId: async (id: number) =>
    ApiWithToken.get(`${aulaService.uri}enrollments/download/?course=${id}`,{
      responseType: "blob",
    }),
  getEnrollmentsByCourseId: async (
    id: number,
    page: number,
    pageSize: number,
    query?: string,
    sortField?: string,
    sortOrder?: string
  ) => {
    return ApiWithToken.get(aulaService.uri + "enrollments/", {
      params: {
        course: id,
        page: page,
        page_size: pageSize,
        search: query || "",
        sort_field: sortField || "student__name",
        sort_direction: sortOrder || "asc",
      },
    });
  },
  getAvailableCourseById: async (id: number) =>
    ApiWithToken.get(`${aulaService.uri}available/?course=${id}`),
  unenroll: async (studentId: number, courseId: number) =>
    ApiWithToken.delete(`${aulaService.uri}unenroll/`, {
      params: { student: studentId, course: courseId },
    }),
  enroll: async (
    name: string,
    email: string,
    documentId: string,
    job: string,
    area: string,
    workplace: string,
    courseId: string
  ) =>
    ApiWithToken.post(`${aulaService.uri}enroll/`, {
      name: name,
      email: email,
      document_id: documentId,
      job: job,
      area: area,
      workplace: workplace,
      course: courseId,
    }),
  getAulaStudentsPdf: async (courseId: string) =>
    ApiWithToken.get(`${aulaService.uri}course_students/${courseId}/`, {
      responseType: "blob",
    }),
  getCertificateData: async (courseId: string) =>
    ApiWithToken.get(`${aulaService.uri}new_course_certificate/${courseId}/`),
  getEnrollmentCertificateData: async (enrollmentId: string) =>
    ApiWithToken.get(
      `${aulaService.uri}enrollment_certificate/${enrollmentId}/`
    ),
  putStudent: async (
    id: number,
    name: string,
    email: string,
    documentId: string,
    job: string,
    area: string,
    workplace: string
  ) =>
    ApiWithToken.put(`${aulaService.uri}?id=${id}`, {
      name: name,
      email: email,
      document_id: documentId,
      job: job,
      area: area,
      workplace: workplace,
    }),
  getStudentByEmail: async (email: string) =>
    ApiWithToken.get(`${aulaService.uri}?email=${email}`),
  markCompletedLectures: async (courseId: number, studentId: number, newStudentId: number) =>
    ApiWithToken.put(`${aulaService.uri}mark_completed/`, {
      course: courseId,
      student: studentId,
      new_student: newStudentId,
    }),
  getActiveEnrollments: async () =>
    ApiWithToken.get(`${aulaService.uri}active_enrollments/`),
  getPreviousEnrollments: async () =>
    ApiWithToken.get(`${aulaService.uri}previous_enrollments/`),
  getEnrollmentProgressById: async (id: string) =>
    ApiWithToken.get(`${aulaService.uri}enrollment/progress/${id}/`),
  markLessonAsCompleted: async (lessonId: string, enrollmentId: string) =>
    ApiWithToken.post(`${aulaService.uri}enrollment/lesson/mark_completed/${lessonId}/`, {
      enrollment_id: enrollmentId,
    }),
  markCongratulationsAsCompleted: async (lessonId: string, enrollmentId: string) =>
    ApiWithToken.post(`${aulaService.uri}enrollment/lesson/mark_congratulations_completed/${lessonId}/`, {
      enrollment_id: enrollmentId,
    }),
  getQuiz: async (id: string) =>
    ApiWithToken.get(`${aulaService.uri}quiz/${id}/`),
  postSatisfactionSurvey: async (enrollmentId: string, data: any) =>
    ApiWithToken.post(`${aulaService.uri}enrollment/${enrollmentId}/satisfaction_survey/`, data),
  getSatisfactionSurvey: async (enrollmentId: string) =>
    ApiWithToken.get(`${aulaService.uri}enrollment/${enrollmentId}/satisfaction_survey/`),
  startAttempt: async (quizId: string, data: any) =>
    ApiWithToken.post(`${aulaService.uri}quiz/${quizId}/attempt/`, data),
  submitAnswers: async (quizId: string, data: any) =>
    ApiWithToken.post(`${aulaService.uri}quiz/${quizId}/answers/`, data),
  getAttempts: async (quizId: string, enrollmentId: string) =>
    ApiWithToken.get(`${aulaService.uri}quiz/${quizId}/attempt/?enrollment_id=${enrollmentId}`),
  getContent: async (id: string) =>
    ApiWithToken.get(`${aulaService.uri}enrollment/lesson/content/${id}/`),
};
